<template>
    <div style="display: flex; justify-content: space-between; align-items: center;">
        <slot></slot>
    </div>
</template>

<script>
import VueBase from './VueBase';


export default class PageHeader extends VueBase {}
</script>